import type { PrintCoordinator } from "./PrintCoordinator.ts";

const PREPARE_TIMEOUT_MS = 15_000;

function waitForPaint() {
    return new Promise<void>(resolve => {
        requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
    });
}

export interface RunPrintOptions {
    isPreparing: boolean;
    coordinator: PrintCoordinator;
    beginPreparation: () => void;
    endPreparation: () => void;
}

export async function runPrint({ isPreparing, coordinator, beginPreparation, endPreparation }: RunPrintOptions) {
    if (isPreparing) {
        return;
    }

    beginPreparation();

    try {
        await coordinator.waitUntilReady({ timeoutMs: PREPARE_TIMEOUT_MS });
        await waitForPaint();

        window.print();
    } finally {
        endPreparation();
    }
}
